module.exports = {"policy":{"footer":"Framasoft,<br />9a de decembro, 2023."}};